import { defaultAgent, apiResponse } from '../helpers/web-agent';
import { toastError, toastSuccess } from './toast';
import { tokenExpired } from './auth';
import { NETWORK_TYPE_LIST, NETWORK_LIST } from '../constants/action-types';
import { ADD_NETWORK, NETWORK_ASSIGN } from '../constants/messages';

export const networkTypeList = payload => ({ type: NETWORK_TYPE_LIST, payload });
export const networkList = payload => ({ type: NETWORK_LIST, payload });


export const getNetworkTypeList = (cb) => dispatch => {
    defaultAgent.get('/api/hardware/networktype').then(res => {
        const agentResult = apiResponse(res, []);
        if (agentResult.isUnauthorized) {
            dispatch(toastError(agentResult.message));
            dispatch(tokenExpired());
            if (cb) cb();
        } else if (agentResult.data) {
            dispatch(networkTypeList(agentResult.data));
            if (cb) cb();
        } else if (agentResult.message) {
            if (cb) cb();
        }
    }).catch(ex => {
        if (defaultAgent.isCancel(ex)) return console.log(`Get Network Type : `, ex.message);
        dispatch(toastError(ex.message));
    });
}

export const addNetwork = (data, cb = null) => dispatch => {
    defaultAgent.post('/api/hardware/add/network', data)
        .then(res => {
            const agentResult = apiResponse(res, {});
            if (agentResult.isUnauthorized) {
                dispatch(toastError(agentResult.message));
                dispatch(tokenExpired());
            } else if (agentResult.code === ADD_NETWORK.code) {
                dispatch(toastSuccess(agentResult.message));
                if (cb) cb(true);
                // dispatch(getUserList(false));
            } else if (agentResult.message) {
                if (agentResult.status === "success") {
                    dispatch(toastSuccess(agentResult.message));
                    if (cb) cb(true);
                } else {
                    dispatch(toastError(agentResult.message));
                    if (cb) cb(false);

                }
            }
        }).catch(ex => {
            dispatch(toastError(ex.message));
            if (cb) cb(false);
        });
};

export const assignNetwork = (data, cb = null) => dispatch => {
    defaultAgent.post('/api/device/assignnetwork', data)
        .then(res => {
            const agentResult = apiResponse(res, {});
            if (agentResult.isUnauthorized) {
                dispatch(toastError(agentResult.message));
                dispatch(tokenExpired());
            } else if (agentResult.code === NETWORK_ASSIGN.code) {
                dispatch(toastSuccess(agentResult.message));
                if (cb) cb(true);
                // dispatch(getUserList(false));
            } else if (agentResult.message) {
                if (agentResult.status === "success") {
                    dispatch(toastSuccess(agentResult.message));
                    if (cb) cb(true);
                } else {
                    dispatch(toastError(agentResult.message));
                    if (cb) cb(false);
                }

            }
        }).catch(ex => {
            dispatch(toastError(ex.message));
            if (cb) cb(false);
        });
};

export const getNetworkList = (farmId, cb) => dispatch => {
    defaultAgent.get('/api/hardware/networklist', { farm_uuid: farmId }).then(res => {
        const agentResult = apiResponse(res, []);
        if (agentResult.isUnauthorized) {
            dispatch(toastError(agentResult.message));
            dispatch(tokenExpired());
            if (cb) cb();
        } else if (agentResult.data) {
            dispatch(networkList(agentResult.data));
            if (cb) cb();
        } else if (agentResult.message) {
            if (cb) cb();
        }
    }).catch(ex => {
        if (defaultAgent.isCancel(ex)) return console.log(`Get Network List: `, ex.message);
        dispatch(toastError(ex.message));
    });
}